export default __webpack_public_path__ + "static/media/Vidalin.2d526567.jpg";